/**
 * Method of trading
 * tag: 338
 * @readonly
 * @enum {number} (int)
 */
export enum TradSesMethod {
  /** Electronic */
  Electronic = 1,
  /** Open Outcry */
  OpenOutcry = 2,
  /** Two Party */
  TwoParty = 3,
  /** Voice */
  Voice = 4,
}
